import React from 'react';

function FilterSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      fill="none"
      viewBox="0 0 18 18"
    >
      <path
        fill="currentColor"
        d="M15.937 13.184h-1.755a1.984 1.984 0 00-1.897-1.425c-.899 0-1.652.604-1.896 1.425H2.062a.563.563 0 000 1.125h8.327c.245.82.998 1.425 1.897 1.425.9 0 1.652-.605 1.897-1.425h1.755a.563.563 0 100-1.125zm-3.652 1.425a.864.864 0 010-1.725.864.864 0 010 1.725zM15.937 8.437H7.61a1.985 1.985 0 00-1.897-1.425c-.9 0-1.652.605-1.897 1.425H2.062a.563.563 0 000 1.125h1.755c.245.82.998 1.425 1.897 1.425.9 0 1.652-.604 1.897-1.425h8.326a.563.563 0 000-1.125zM5.714 9.862a.864.864 0 010-1.725.864.864 0 010 1.725zM2.062 4.816h5.771A1.984 1.984 0 009.73 6.241c.9 0 1.652-.604 1.897-1.425h4.31a.563.563 0 000-1.125h-4.31A1.985 1.985 0 009.73 2.266c-.9 0-1.652.605-1.897 1.425h-5.77a.563.563 0 000 1.125zM9.73 3.391a.864.864 0 010 1.725.864.864 0 010-1.725z"
      ></path>
    </svg>
  );
}

export default FilterSvg;
